<template>
  <main class="g-bg-attachment-fixed g-bg-black-opacity-0_1">
    <!-- Main Banner -->
    <section id="score" class="js-carousel g-overflow-hidden g-max-height-100vh">
      <transition name="fade">
        <div id="score" v-if="display==='score'">
          <!-- Promo Block -->
          <div class="g-flex-centered g-height-100vh g-min-height-500--md g-bg-cover g-bg-pos-center g-bg-img-hero">
            <div class="m-3 fixed-top text-center g-color-white"
                 v-if="currentTweet">
              <div class="container g-bg-black-opacity-0_5 g-rounded-5">
                <span class="g-font-size-24--md g-font-size-45--lg">
                  <i class="fa fa-twitter g-color-twitter"></i>
                  {{currentTweet.author}} - {{currentTweet.content}}
                </span>
              </div>
            </div>
            <div v-else class="m-2 fixed-top container-fluid row mx-auto">
              <div class="col-4">
              </div>
              <div class="col-4 text-center g-color-white align-middle">
                <img src="/static/img/OpenBlancRose.png" alt="Logo" class='logo'>
              </div>
              <div class="col-4">
              </div>
            </div>

            <div class="container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_5 g-rounded-5"
                 v-if="currentMatch">
              <div class="row">
                <div class="col-2">
                  <img class="img-fluid mx-auto d-block g-rounded-20" v-bind:src="getFace(currentMatch.player1.face)">
                </div>
                <div class="col-8">
                  <h2
                    class="text-uppercase g-font-weight-700 g-font-size-default g-font-size-26--md g-font-size-50--lg">
                    {{currentMatch.player1.displayname}}<span> - </span>{{currentMatch.player2.displayname}}
                  </h2>
                  <br/>
                  <div class="g-font-weight-500 g-font-size-default g-font-size-22--md g-font-size-40--lg g-mb-20">
                    {{currentMatch.date | formatDate}} - {{currentMatch.round}}
                  </div>
                </div>
                <div class="col-2">
                  <img class="img-fluid mx-auto d-block g-rounded-20" v-bind:src="getFace(currentMatch.player2.face)">
                </div>
              </div>
              <div>
                <table class="table g-font-weight-500 g-font-size-default g-font-size-24--md g-font-size-50--lg g-mb-10"
                       v-if="currentMatch.startDate">
                  <thead>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>1</td>
                    <td>2</td>
                    <td>3</td>
                    <td>Pts</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      <img class="g-rounded-10 mx-auto country"
                           v-bind:src="getCountryFlag(currentMatch.player1.country)">
                    </td>
                    <th class="text-left">{{currentMatch.player1.firstname}} {{currentMatch.player1.lastname}}</th>
                    <td>
                      <figure :class="getFlag(currentMatch,1)"></figure>
                    </td>
                    <td>{{currentMatch.sets[0].scorePlayer1}}</td>
                    <td>{{currentMatch.sets[1].scorePlayer1}}</td>
                    <td>{{currentMatch.sets[2].scorePlayer1}}</td>
                    <td>{{currentMatch.currentPointPlayer1}}</td>
                  </tr>
                  <tr>
                    <td>
                      <img class="g-rounded-10 mx-auto country"
                           v-bind:src="getCountryFlag(currentMatch.player2.country)">
                    </td>
                    <th class="text-left">{{currentMatch.player2.firstname}} {{currentMatch.player2.lastname}}</th>
                    <td>
                      <figure :class="getFlag(currentMatch,2)"></figure>
                    </td>
                    <td>{{currentMatch.sets[0].scorePlayer2}}</td>
                    <td>{{currentMatch.sets[1].scorePlayer2}}</td>
                    <td>{{currentMatch.sets[2].scorePlayer2}}</td>
                    <td>{{currentMatch.currentPointPlayer2}}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <th class="text-left">{{getTotalDuration(currentMatch.startDate, currentMatch.endDate,
                      currentMatch.currentDate)}}
                    </th>
                    <td></td>
                    <td> {{getDuration(currentMatch.sets[0].startDate, currentMatch.sets[0].endDate,
                      currentMatch.currentDate)}}
                    </td>
                    <td> {{getDuration(currentMatch.sets[1].startDate, currentMatch.sets[1].endDate,
                      currentMatch.currentDate)}}
                    </td>
                    <td> {{getDuration(currentMatch.sets[2].startDate, currentMatch.sets[2].endDate,
                      currentMatch.currentDate)}}
                    </td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_6 g-rounded-15" v-else>
              <h2>Coming Soon</h2>
            </div>

            <div class="fixed-bottom container-fluid row mx-auto g-bg-black-opacity-0_3">


              <div class="col-1 m-auto">
                <img src="/static/img/sponsor/crocus.png" alt="Logo" class='logo'>
              </div>

              <div class="col-2 m-auto">
                <img src="/static/img/sponsor/jurzak2.png" alt="Logo" class='logo'>
              </div>

              <div class="col-2 m-auto">
                <img src="/static/img/sponsor/leclerc-fit.png" alt="Logo" class='logo'>
              </div>

              <div class="col-2 m-auto">
                <img src="/static/img/sponsor/verspieren-3.png" alt="Logo" class='logo'>
              </div>

              <div class="col-2 m-auto">
                <img src="/static/img/sponsor/legallais-fit.png" alt="Logo" class='logo'>
              </div>

              <div class="col-1 m-auto">
                <img src="/static/img/sponsor/villaeugene2.png" alt="Logo" class='logo'>
              </div>
            </div>
          </div>
          <!-- End Promo Block -->
        </div>
      </transition>
      <transition name="fade">
        <div id="stat" v-if="display==='stat'">
          <!-- Promo Block -->
          <div class="g-flex-centered g-height-100vh g-min-height-500--md g-bg-cover g-bg-pos-center g-bg-img-hero">
            <div class="container text-center g-color-white g-z-index-1 g-bg-black-opacity-0_4 g-rounded-15">
              <div class="row">
                <div class="col-2">
                  <img class="img-fluid mx-auto d-block g-rounded-20" v-bind:src="getFace(currentStat[0].player.face)">
                </div>
                <div class="col-8">
                  <h2 class="g-font-size-default g-font-size-26--md g-font-size-50--lg">
                    {{currentStat[0].player.displayname}}<span> - </span>{{currentStat[1].player.displayname}}
                  </h2>
                  <br/>
                </div>
                <div class="col-2">
                  <img class="img-fluid mx-auto d-block g-rounded-20" v-bind:src="getFace(currentStat[1].player.face)">
                </div>
              </div>
              <div class="g-my-10 g-font-size-default g-font-size-20--md g-font-size-36--lg">
                <div class="row">
                  <div class="col-3">
                    {{currentStat[0].ace}}
                  </div>
                  <div class="col-6">ACES</div>
                  <div class="col-3">
                    {{currentStat[1].ace}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar progress-reverse" role="progressbar"
                           v-bind:style="{ width: getPercentage(currentStat[0].ace,currentStat[0].ace + currentStat[1].ace) +'%'}"></div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar" role="progressbar"
                           v-bind:style="{ width: getPercentage(currentStat[1].ace,currentStat[0].ace + currentStat[1].ace) +'%'}"></div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    {{currentStat[0].doubleFault}}
                  </div>
                  <div class="col-6">DOUBLES FAUTES
                  </div>
                  <div class="col-3">
                    {{currentStat[1].doubleFault}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar progress-reverse" role="progressbar"
                           v-bind:style="{ width: getPercentage(currentStat[0].doubleFault,currentStat[0].doubleFault + currentStat[1].doubleFault) +'%' }">
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar" role="progressbar"
                           v-bind:style="{ width: getPercentage(currentStat[1].doubleFault,currentStat[0].doubleFault + currentStat[1].doubleFault) +'%' }">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    {{currentStat[0].firstServeIn}}
                  </div>

                  <div class="col-6">PREMIERS SERVICES
                  </div>

                  <div class="col-3">
                    {{currentStat[1].firstServeIn}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar progress-reverse" role="progressbar"
                           v-bind:style="{ width: extractPercentage(currentStat[0].firstServeIn) +'%' }">
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar" role="progressbar"
                           v-bind:style="{ width: extractPercentage(currentStat[1].firstServeIn) +'%' }">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    {{currentStat[0].firstServeWon}}
                  </div>

                  <div class="col-6">POINTS GAGNES 1ER SERVICE
                  </div>

                  <div class="col-3">
                    {{currentStat[1].firstServeWon}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar progress-reverse" role="progressbar"
                           v-bind:style="{ width: extractPercentage(currentStat[0].firstServeWon) +'%' }">
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar" role="progressbar"
                           v-bind:style="{ width: extractPercentage(currentStat[1].firstServeWon) +'%' }">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    {{currentStat[0].secondServeWon}}
                  </div>

                  <div class="col-6">POINTS GAGNES 2ND SERVICE
                  </div>

                  <div class="col-3">
                    {{currentStat[1].secondServeWon}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar progress-reverse" role="progressbar"
                           v-bind:style="{ width: extractPercentage(currentStat[0].secondServeWon) +'%' }">
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar" role="progressbar"
                           v-bind:style="{ width: extractPercentage(currentStat[1].secondServeWon) +'%' }">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    {{currentStat[0].breakWon}}
                  </div>

                  <div class="col-6">BALLES DE BREAK
                  </div>

                  <div class="col-3">
                    {{currentStat[1].breakWon}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar progress-reverse" role="progressbar"
                           v-bind:style="{ width: extractPercentage(currentStat[0].breakWon) +'%' }">
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar" role="progressbar"
                           v-bind:style="{ width: extractPercentage(currentStat[1].breakWon) +'%' }">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    {{currentStat[0].winners}}
                  </div>

                  <div class="col-6">POINTS GAGNANTS
                  </div>

                  <div class="col-3">
                    {{currentStat[1].winners}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar progress-reverse" role="progressbar"
                           v-bind:style="{ width: getPercentage(currentStat[0].winners,currentStat[0].winners + currentStat[1].winners) +'%' }">
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar" role="progressbar"
                           v-bind:style="{ width: getPercentage(currentStat[1].winners,currentStat[0].winners + currentStat[1].winners) +'%' }">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    {{currentStat[0].unforcedErrors}}
                  </div>

                  <div class="col-6">FAUTES DIRECTES
                  </div>

                  <div class="col-3">
                    {{currentStat[1].unforcedErrors}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar progress-reverse" role="progressbar"
                           v-bind:style="{ width: getPercentage(currentStat[0].unforcedErrors,currentStat[0].unforcedErrors + currentStat[1].unforcedErrors) +'%' }">
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar" role="progressbar"
                           v-bind:style="{ width: getPercentage(currentStat[1].unforcedErrors,currentStat[0].unforcedErrors + currentStat[1].unforcedErrors) +'%' }">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    {{currentStat[0].forcedErrors}}
                  </div>

                  <div class="col-6">FAUTES PROVOQUEES
                  </div>

                  <div class="col-3">
                    {{currentStat[1].forcedErrors}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar progress-reverse" role="progressbar"
                           v-bind:style="{ width: getPercentage(currentStat[0].forcedErrors,currentStat[0].forcedErrors + currentStat[1].forcedErrors) +'%' }">
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar" role="progressbar"
                           v-bind:style="{ width: getPercentage(currentStat[1].forcedErrors,currentStat[0].forcedErrors + currentStat[1].forcedErrors) +'%' }">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    {{currentStat[0].totalPointWon}}
                  </div>

                  <div class="col-6">TOTAL POINTS GAGNES
                  </div>

                  <div class="col-3">
                    {{currentStat[1].totalPointWon}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar progress-reverse" role="progressbar"
                           v-bind:style="{ width: getPercentage(currentStat[0].totalPointWon,currentStat[0].totalPointWon + currentStat[1].totalPointWon) +'%' }">
                      </div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="progress">
                      <div class="progress-bar" role="progressbar"
                           v-bind:style="{ width: getPercentage(currentStat[1].totalPointWon,currentStat[0].totalPointWon + currentStat[1].totalPointWon) +'%' }">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div id="player" v-if="display==='player'">
          <!-- Promo Block -->
          <img class="img-fluid" v-bind:src="getCard(currentPlayer.face)">
        </div>
      </transition>
    </section>
  </main>
</template>

<script>
  export default {
    data () {
      return {
        currentMatch: undefined,
        currentPlayer: undefined,
        currentStat: undefined,
        currentTweet: undefined,
        display: 'score'
      }
    },
    sockets: {
      displayMatch (data) {
        if (data) {
          this.currentMatch = data
          this.display = 'score'
        }
      },
      displayPlayer (data) {
        if (data) {
          console.log('receive player ' + JSON.stringify(data))
          this.currentPlayer = data
          this.display = 'player'
        }
      },
      displayStat (data) {
        if (data) {
          console.log('receive stats ' + JSON.stringify(data))
          this.currentStat = data
          this.display = 'stat'
        }
      },
      displayTweet (data) {
        if (data) {
          console.log('receive tweet ' + JSON.stringify(data))
          this.currentTweet = data
          setTimeout(() => {
            this.currentTweet = undefined
          }, 10000)
        }
      }
    },
    methods: {
      getTotalDuration: function (startDate, endDate, currentDate) {
        if (startDate) {
          const sDate = new Date(startDate)
          const eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date()
          let duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000)
          if (duration < 0) {
            duration = 0
          }
          let hours = Math.floor(duration / 3600)
          let minutes = Math.floor((duration - (hours * 3600)) / 60)

          if (minutes < 10) {
            minutes = '0' + minutes
          }
          return hours + ':' + minutes
        } else {
          return '0\''
        }
      },
      getDuration: function (startDate, endDate, currentDate) {
        if (startDate) {
          const sDate = new Date(startDate)
          const eDate = endDate ? new Date(endDate) : currentDate ? new Date(currentDate) : new Date()
          let duration = Math.round((eDate.getTime() - sDate.getTime()) / 1000)
          if (duration < 0) {
            duration = 0
          }
          let hours = Math.floor(duration / 3600)
          let minutes = Math.floor((duration - (hours * 3600)) / 60) + hours * 60

          return minutes + '\''
        } else {
          return '0\''
        }
      },
      getFlag: function (match, playerIndex) {
        if (!match || !match.flags) {
          return ''
        }
        if (match.flags.winnerId === playerIndex) {
          return 'flagWinner'
        } else if (match.flags.serverId === playerIndex) {
          var scoreServer = match.currentPointPlayer1
          var scoreOther = match.currentPointPlayer2
          if (match.flags.serverId === 2) {
            scoreServer = match.currentPointPlayer2
            scoreOther = match.currentPointPlayer1
          }
          if (scoreOther === 'A') {
            return 'flagBreak'
          }
          if (scoreOther === '40') {
            if (scoreServer !== '40' && scoreServer !== 'A') {
              return 'flagBreak'
            }
          }
          return 'flagBall'
        }
        return ''
      },
      getCountryFlag: function (country) {
        if (!country) {
          return ''
        } else {
          return 'static/img/country/' + country.toLowerCase() + '.gif'
        }
      },
      getFace: function (face) {
        if (!face) {
          return 'static/img/player/face/avatar.jpg'
        }
        return 'static/img/player/face/' + face
      },
      getCard: function (face) {
        if (face) {
          return '/static/img/player/card/' + face.replace('png', 'jpg').toLowerCase()
        }
      },
      getLogo: function (logo) {
        if (logo) {
          return 'static/img/sponsor/' + logo
        }
      },
      getPercentage: function (value, total) {
        if (!value || !total) {
          return 0
        }
        if (value <= 0) {
          return 0
        }
        if (value >= total) {
          return 100
        }
        return (value * 100) / total
      },
      extractPercentage: function (value) {
        if (!value) {
          return 0
        }
        var i = value.indexOf('%')
        if (i <= 0) {
          return value
        }
        return value.substring(0, i)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/Zenith.vue